import { SidebarItem } from 'types/types';

export class Utils {
  static async delay(seconds: number): Promise<void> {
    return new Promise<void>((resolve) => {
      setTimeout(resolve, seconds * 1000);
    });
  }
  // Add more  functions here...
}

export const generateQueryParams = (properties) => {
  //return a urlEncoded urlParams based on an nvp array [{Name:'param1Name',Value:'param1Value'}]
  const queryParams = Array<any>();
  for (const prop of properties) {
    const { Name, Value } = prop;
    queryParams.push(
      `${encodeURIComponent(Name)}=${encodeURIComponent(Value)}`
    );
  }
  return queryParams.join('&');
};

export const isSwitchable = (view: SidebarItem) => {
  const switchableProperty =
    view.properties?.filter((_) => _.Name == 'is_switchable') || [];
  return (
    switchableProperty.length == 0 ||
    switchableProperty[0].Value.toLowerCase() == 'true'
  );
};
 
export const getSidebarItemProp = (
  item: SidebarItem,
  prop: string,
  defaultValue: string = ''
) => { 
  return item.properties?.find((_) => _.Name == prop)?.Value || defaultValue;
};
